// Types
import { NewFeatureCarouselModalType } from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal.types';
import { Illustrations } from 'Wpds/components/illustration';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

export const Data = {
  slides: [
    {
      slug: 'compiler-review-completed-slide',
      title: '360 Feedback Submitted',
      imageBgColor: Colors.purple[25],
      image: Illustrations.high_fiving_purple_bg,
      imageWidth: '140px',
      nextBtnLabel: 'Done',
      description: `Nice work on that 360. We’ve created a discussion topic in your 1:1 workspace and notified them letting them know the compilation is done and ready to discuss soon.`,
    },
  ],
} as NewFeatureCarouselModalType;
